<template>
    <div style="background: #ffffff;width:355px;margin:0 auto 0;">
        <p class="listTitle">{{title}}</p>
        <div class="new-introduce">
            <div class="introduce-img" >
                <img :src="imgUrl" style="width: 100%;"/>
            </div>
<!--            <div class="liFlex">-->
                <div class="li" v-for="item in list" :key="item.id" @click="to_detail(item.id)">
                    <div class="img">
                        <img :src="require('@/assets/image/product/'+item.image)">
                    </div>
                    <div class="item">{{item.name}}</div>
                </div>
<!--            </div>-->

            <div style="clear: both"></div>
        </div>
    </div>
</template>

<script>
    import homeNews from '@/assets/image/home/home-new.png'
    import homeDerivative from '@/assets/image/home/home-derivative.png'
    import homeBasics from '@/assets/image/home/home-basics.png'
    export default {
        name: "wapNewEnergy",
        props:['title','list','type'],
        data(){
            return{
                imgUrl:''
            }
        },
        mounted() {
            if(this.type==1){
                this.imgUrl=homeNews;
            }else if(this.type==2){
                this.imgUrl=homeDerivative;
            }else if(this.type==3){
                this.imgUrl=homeBasics;
            }
        },
        methods:{
            to_detail(id){
                // this.$router.push('/productDetail?id='+id);
                let pathName =  window.location.pathname;
                if(pathName ==` '/productDetail?id='+${id}&wapShow=true`)return;
                this.$router.push({
                    path:'/productDetail?id='+id,
                    query:{wapShow:true}
                });
            }
        }
    }
</script>

<style scoped>
    .listTitle{
        padding-bottom: 10px;
        height: 18px;
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3A3A3A;
        line-height: 18px;
    }
    .new-introduce{
        width: 355px;
        text-align: left;
    }
    .introduce-img{
        width:355px;
        height: 168px;
        border-radius: 10px;
        margin-bottom:14px;
    }
    .new-introduce .li{
        width: 168px;
        height: 168px;
        border-radius: 10px;
        overflow: hidden;
        float: left;
        margin-bottom: 11px;
        border: 2px solid #E6E8EB;
        cursor: pointer;
    }
    .new-introduce .li:nth-child(0){margin-right: 11px;}
    .new-introduce .li:nth-child(2){margin-right: 11px;}
    .new-introduce .li:nth-child(4){margin-right: 11px;}

    /*.new-introduce .li:nth-child(5){margin-right: 180px;}*/

    .new-introduce .li .img{
        width: 168px;
        height: 131px;
        background: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .new-introduce .li .img img{
        height: 100%;
    }
    .new-introduce .li .item{
        width: 168px;
        height: 41px;
        background: #0067AC;
        color: #FFFFFF;
        box-sizing: border-box;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 35px;
        padding-left:6px;
    }
    .liFlex{
        width:355px;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
    }
</style>
